import React from 'react'
import { connect } from 'react-redux'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'

const CreateAgent = (props) => {
    const submitFX = (formData, formId) => {
        console.log('submit the form')
    }

    const successFX = (agentId) => {
        console.log('time to forward')
    }

    return (
        <div>
            <h1>Create Agent</h1>
            <SHSForm successFX={successFX} submitFX={submitFX}>
                <InputElement
                    type="text"
                    id="firstName"
                    label="First Name"
                    extraClass="flex-50"
                    required />
                <InputElement
                    type="text"
                    id="lastName"
                    label="Last Name"
                    extraClass="flex-50"
                    required />
                <InputElement
                    type="email"
                    id="email"
                    label="Email"
                    extraClass="flex-50"
                    required />
                <InputElement
                    type="text"
                    id="phone"
                    label="Phone"
                    extraClass="flex-50"
                    required />
            </SHSForm>

        </div>
    )
}

export default connect()(CreateAgent)
